"use client";

//
import { ErrorMessage } from "@/components";
import { cleanSEOTags } from "@/utilities";

export const ShareholderDiscloser = ({
    data = {},
    slug = "disclosure_regulation_table",
}) => {
    console.log(data);

    const { row_heading = [], row_description = [] } = data;
    let counter = 0;


    return (
        <>
            <div
                className="team__section governance_table_tabing disclosure__table shareholder__table"
                id={slug}
            >
                <div className="custom-container">
                    <div
                        className="item__tab_data tab-active"
                        data-id="quarterly-corporate-one"
                    >
                        <div className="table_quarterly_corporate multiple__column">
                            <table className="fs-20 fw-600">
                                <thead>
                                    <tr>
                                        <th>SR. No.</th>
                                        <th
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    cleanSEOTags(
                                                        row_heading?.[0]
                                                            ?.column_one,
                                                    ) || "Category",
                                            }}
                                        />
                                        <th
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    cleanSEOTags(
                                                        row_heading?.[0]
                                                            ?.column_two,
                                                    ) || "No. of Cases",
                                            }}
                                        />
                                        <th
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    cleanSEOTags(
                                                        row_heading?.[0]
                                                            ?.column_three,
                                                    ) || "Total Shares",
                                            }}
                                        />
                                        <th
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    cleanSEOTags(
                                                        row_heading?.[0]
                                                            ?.column_four,
                                                    ) || "% to Equity",
                                            }}
                                        />
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(row_description) &&
                                    row_description.length > 0 ? (
                                        row_description.map((row, idx) => {
                                            if (!row?.column_one) return null;

                                            const isTotal =
                                                row.column_one.toUpperCase() ===
                                                "TOTAL";
                                            if (!isTotal) counter++;

                                            return (
                                                <tr
                                                    key={idx}
                                                    className={
                                                        isTotal ? "fw-700" : ""
                                                    }
                                                >
                                                    <td>
                                                        {isTotal
                                                            ? ""
                                                            : `${counter}.`}
                                                    </td>
                                                    <td
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                cleanSEOTags(
                                                                    row.column_one,
                                                                ) || "-",
                                                        }}
                                                    />
                                                    <td
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                cleanSEOTags(
                                                                    row.column_two,
                                                                ) || "-",
                                                        }}
                                                    />
                                                    <td
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                cleanSEOTags(
                                                                    row.column_three,
                                                                ) || "-",
                                                        }}
                                                    />
                                                    <td
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                cleanSEOTags(
                                                                    row.column_four,
                                                                ) || "-",
                                                        }}
                                                    />
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={5}
                                                className="text-center"
                                            >
                                                <ErrorMessage>
                                                    No data available
                                                </ErrorMessage>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
